import EndPointConfig from '../../models/api/EndPointConfig'

const controller = 'Agencies'

export const AgenciesEP : EndPointConfig[] =[
    new EndPointConfig()
        .setMethod("GET")
        .setController(controller)
        .setActionName("GetAgencies")
]